import { render, staticRenderFns } from "./AssignmentModel.vue?vue&type=template&id=0be6199b&"
import script from "./AssignmentModel.vue?vue&type=script&lang=js&"
export * from "./AssignmentModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports